'use strict';
import $ from 'jquery';

import ET from './global-helpers';

// The parts from main.js that were still in use

export default {
  init: function() {
    //Fix home page grid behaviour
    (function(){
      $('body.home .article-list .row').each(function(i, row) {
        var children = $(row).children();

        //Medium special behaviour
        if(children.filter('.large-6').length === 1 && children.filter('.large-3').length === 2) {
          //1big, 2 small row
          $(row).addClass('md-special-row');
        }else if(children.filter('.large-3').length === 4) {
          //4 small
          children.each(function(ii, col) {
            if((ii+1) % 2 === 0 && (ii+1) < children.length) {
              $(col).after('<div class=\'dummy-row-clearer clearer md-special-break\'></div>');
            }
          });
        }

      });
    }());

    //General scroll-to link
    $('body').on('click', 'a.scroll-to', function(e) {
      e.preventDefault();
      var target = $(this.hash);

      //If inside collapsible, toggle the collapsible open
      if(target.closest('.collapsible').length) {
        target.closest('.collapsible').addClass('open');
        $(window).trigger('resize'); //Trigger needed for TOC to calculate new positions
      }

      ET.scrollTo(target, {animate: true}, function() {
        //Set focus to scrolled element
        target.attr('tabindex', '-1').trigger('focus');
      });
    });

    //Share functionality
    $(document).on('click', '.share-article a.share', function(e) {
      e.preventDefault();
      $(this).next('.services').toggleClass('open'); //Slide open share buttons
    });

    $(document).on('click', 'a.email-share', function(e) {
      e.preventDefault();
      //Set iframe url
      if($('.offcanvas-share-email iframe').attr('src') === '') {
        $('.offcanvas-share-email iframe').attr('src', this.href);
      }
    });

    // Fix for newsletter iframe triggering input/zoom on iOS8
    $('[data-toggle-offcanvas="newsletter-open"]').on('click', function(){
      var url = $(this).data('url');
      $('.offcanvas-newsletter iframe').attr('src', url);
    });

    $(window).on('load', function() {

      //Scroll to first form that has error
      var errorForms = $('.stage-form.stage-error');
      if(errorForms.length) {
        ET.scrollTo(errorForms.first(), {animate: false}, function() {
          //Set focus to scrolled element
          errorForms.first().find('input').first().trigger('focus');
        });
      }
    });
  }
};
